import styled from 'styled-components'
import { createPortal } from 'react-dom'
import { ModalSpace } from 'src/provider/ModalContextProvider'
import { ModalProps } from 'src/components/common/Modal/index'
import {
  Noto_body1_b16,
  Noto_body1_r16,
  Noto_body2_m14,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import RenderIf from 'src/components/common/RenderIf'

const ModalView = ({ modalData, onSubmitInternal, onCancelInternal }: ModalProps) => {
  const { button, contents } = modalData as ModalSpace.ModalData
  const rowDirection = button?.direction !== 'column'

  return createPortal(
    <S.ModalBackGroundWrap id="modal">
      <S.ModalWrap>
        <S.ModalInner>
          <S.ModalTitle $active={!!contents?.t}> {contents?.t}</S.ModalTitle>
          <S.ModalContents $active={!!contents?.d}>{contents?.d}</S.ModalContents>
          <S.ModalChildren>{contents?.children}</S.ModalChildren>
          <S.ModalButtonColumnWrap>
            <RenderIf
              when={(rowDirection && Boolean(button?.cancel?.t)) || Boolean(button?.submit?.t)}
            >
              <S.ModalButtonRowWrap>
                <RenderIf when={rowDirection && Boolean(button?.cancel?.t)}>
                  <S.ModalSecondaryButton onClick={onCancelInternal}>
                    {button?.cancel?.t}
                  </S.ModalSecondaryButton>
                </RenderIf>
                <RenderIf when={Boolean(button?.submit?.t)}>
                  <S.ModalPrimaryButton onClick={onSubmitInternal}>
                    {button?.submit?.t}
                  </S.ModalPrimaryButton>
                </RenderIf>
              </S.ModalButtonRowWrap>
            </RenderIf>
            <RenderIf when={!rowDirection && Boolean(button?.cancel?.t)}>
              <S.ModalGhostButton onClick={onCancelInternal}>
                {button?.cancel?.t}
              </S.ModalGhostButton>
            </RenderIf>
          </S.ModalButtonColumnWrap>
        </S.ModalInner>
      </S.ModalWrap>
    </S.ModalBackGroundWrap>,
    document.body,
  )
}
export default ModalView

const S = {
  ModalBackGroundWrap: styled.div`
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
  ModalWrap: styled.div`
    width: 100%;
    max-width: 360px;
    min-width: 280px;
    margin: 0 40px;
  `,
  ModalInner: styled.div`
    max-width: 360px;
    width: 100%;
    padding: 26px 24px;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
  `,
  ModalChildren: styled.div``,
  ModalTitle: styled.p<{ $active: boolean }>`
    display: ${(props) => (props.$active ? ' block' : 'none')};
    text-align: center;
    ${Noto_subheading_b18};
    margin-bottom: 10px;
    white-space: pre-wrap;
  `,
  ModalContents: styled.span<{ $active: boolean }>`
    display: ${(props) => (props.$active ? 'block' : 'none')};
    width: 100%;
    height: 100%;
    max-height: 212px;
    overflow: auto;
    ${Noto_body1_r16};
    white-space: pre-wrap;
    margin: 0 auto 26px auto;
  `,
  ModalButtonRowWrap: styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 12px;
  `,
  ModalButtonColumnWrap: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
  `,
  ModalSecondaryButton: styled.button`
    background: #e5f2ff;
    color: var(--brand-50);
    width: 100%;
    border-radius: 12px;
    padding: 12px;
    align-items: center;
    ${Noto_body1_b16};
  `,
  ModalPrimaryButton: styled.button`
    background: var(--brand-50);
    color: white;
    width: 100%;
    border-radius: 12px;
    padding: 12px;
    align-items: center;
    ${Noto_body1_b16};
  `,
  ModalGhostButton: styled.button`
    width: 100%;
    padding: 3px 10px;
    color: var(--black-50);
    ${Noto_body2_m14};
  `,
}
